import React, { useRef, useEffect } from 'react';
import * as S from '../FieldsDropdown/style';

interface FiltersDropdownProps {
  fieldType: 'string' | 'number' | 'date' | 'boolean' | 'currency' | 'price';
  fieldKey?: string;
  onSelect: (type: string) => void;
  close: () => void;
}

const numericOptions = ['Igual a', 'Diferente de', 'Maior que', 'Menor que', 'É maior/igual que', 'É menor/igual que'];

const filterOptions = {
  string: ['Contém', 'Não contém', 'Igual a', 'É diferente de', 'Começa com', 'Termina com'],
  number: numericOptions,
  currency: numericOptions,
  price: numericOptions,
  date: ['Igual a', 'Antes de', 'Depois de', 'Intervalo'],
  boolean: [],
};

const FiltersDropdown: React.FC<FiltersDropdownProps> = ({ fieldType, fieldKey, onSelect, close }) => {
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        close();
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [close]);

  if (fieldType === 'boolean') {
    return (
      <S.DropdownContainer ref={dropdownRef}>
        <S.DropdownItem onClick={() => onSelect('Igual a')}>
          Igual a
        </S.DropdownItem>
      </S.DropdownContainer>
    );
  }

  const options = filterOptions[fieldType] || filterOptions.string;

  return (
    <S.DropdownContainer ref={dropdownRef}>
      {options.map((type) => (
        <S.DropdownItem key={type} onClick={() => onSelect(type)}>
          {type}
        </S.DropdownItem>
      ))}
    </S.DropdownContainer>
  );
};

export default FiltersDropdown;